<template>
    <div class="setup-container">
        <div class="header-search">
            <button class="setup-btn" @click="showModal=true">
                <Plus class="icon" />
                <p style="padding: 0%; margin: 0%;">Make Payment</p>
            </button>
            <div class="search-bar">
                <Search />
                <input type="text" placeholder="Search..." v-model="searchQuery" />
            </div>
        </div>
        <div>
            <p class="application-title">Payments</p>
        </div>
        <!-- Table -->
        <table class="table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>amount</th>
                    <th>Description</th>
                    <th>Date Paid</th>
                    <th>Payment type</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in paginatedData" :key="item.id">
                    <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                    <td>{{ item.amount }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.date_paid }}</td> 
                    <td>{{ item.payment_status }}</td> 
                </tr>
            </tbody>
        </table>

        <!-- Pagination -->
        <div class="pagination">
            <button @click="prevPage" :disabled="currentPage === 1">
                <ChevronLeft />
            </button>
            <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
                :class="{ active: currentPage === page }">
                {{ page }}
            </button>
            <button @click="nextPage" :disabled="currentPage === totalPages">
                <ChevronRight />
            </button>
        </div>
    </div>
    <div
    v-if="showModal"
    class="modal fade show"
    style="display: block; background: rgba(0, 0, 0, 0.6);"
    @click.self="closeModal"
>
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content rounded-3 shadow-lg border-0">
            <!-- Header -->
            <div style="background-color: #ED4E24;" class="modal-header text-white rounded-top">
                <h5 class="modal-title fw-bold">
                    <i class="fa fa-id-card me-2"></i> Fees Type
                </h5>
                <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
            </div>

            <!-- Body -->
            <div class="modal-body">
                <div class="row mb-4">
                    <div class="col-md-12">
                        <label class="form-label fw-bold">Select Fees Type:</label>
                        <select class="form-control" v-model="payment_type" @change="onPaymentTypeChange">
                            <option value="">-Select fees type-</option>
                            <option value="annual-subscription">Annual Subscription</option>
                            <option value="levy">Levy</option>
                            <option value="sponsorship">Sponsorship</option>
                            <option value="donation">Donation</option>
                            <option value="advert">Advert</option>
                        </select>
                    </div>
                </div>

                <div class="row mb-4" v-if="showAdvertInput">
                    <div class="col-md-12">
                        <label class="form-label fw-bold">Select Advert</label>
                        <select class="form-control" v-model="advert_type">
                            <option value="">-Select advert-</option>
                            <option v-for="(data, index) in advertList" :key="index" :value="data.id">{{ data.title }} - ({{ data.is_active }})</option>
                           
                        </select>
                    </div>
                </div>

                <!-- Amount Input Section (Shows for sponsorship and other) -->
                <div v-if="showAmountInput" class="row mb-4">
                    <div class="col-md-12">
                        <label class="form-label fw-bold">Amount (₦):</label>
                        <div class="input-group">
                            <span class="input-group-text">₦</span>
                            <input 
                                type="number" 
                                class="form-control" 
                                v-model="customAmount"
                                :placeholder="getAmountPlaceholder()"
                                min="0"
                                step="0.01"
                                @input="formatAmount"
                            >
                            <span class="input-group-text">.00</span>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Footer -->
            <div class="modal-footer bg-light d-flex justify-content-end gap-2">
                <button 
                    class="btn btn-success" 
                    @click="makePayment"
                >
                    <i class="fa fa-credit-card me-1"></i> Proceed to Payment
                </button>
                <button class="btn btn-secondary" @click="closeModal">
                    <i class="fa fa-times me-1"></i> Close
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script setup>
/* eslint-disable */ 
import { ArrowUpRight, ChevronLeft, ChevronRight, PenLine, Search, Trash } from "lucide-vue-next";
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';
import PaystackPop from '@paystack/inline-js';

const dataList = ref([]);
const dataFee = ref([])
const advertFee = ref([])
const showModal = ref(false);
let created_by = ref(localStorage.getItem('userid'));
let email = ref(localStorage.getItem('email_address'));
const payment_type = ref('')
const customAmount = ref('')
const paymentDescription = ref('')
const advert_type = ref('')
const advertList = ref([])
const donationList = ref('')
const donationFee = ref('')

// Pagination state
const currentPage = ref(1);
const pageSize = 8;

onMounted( async () => {
  await listRecords();
  await getMembershipFees();
  await getAdvertFees()
  await listAdvertRecords()
});

onBeforeUnmount( async () => {
  
});

// Computed values
const totalPages = computed(() =>
    Math.ceil(dataList.value.length / pageSize)
);

const paginatedData = computed(() => {
    const start = (currentPage.value - 1) * pageSize;
    return dataList.value.slice(start, start + pageSize);
});

// Pagination methods
function goToPage(page) {
    if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
    }
}

function prevPage() {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}

function nextPage() {
    if (currentPage.value < totalPages.value) {
        currentPage.value++;
    }
}

// Action methods
const onPaymentTypeChange = ()=>{
    // Reset custom amount when changing payment type
    customAmount.value = '';
}

const showAmountInput = computed(() => {
        return payment_type.value === 'sponsorship' || payment_type.value === 'levy' || payment_type.value === 'donation';
    }
)

const showAdvertInput = computed(() => {
        return payment_type.value === 'advert';
    }
)

const getAmountPlaceholder = () => {
    if (payment_type.value === 'sponsorship') {
        return 'Enter sponsorship amount (e.g., 1000)';
    } else if (payment_type.value === 'levy') {
        return 'Enter levied amount (e.g., 1000)';
    }
    else if (payment_type.value === 'donation') {
        return 'Enter donation amount (e.g., 10000)';
    }

    return '';
}
const formatCurrency = (amount) => {
    // Format number with commas
    return amount.toLocaleString('en-NG', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
const listAdvertRecords = async () => {
  try {
    const response = await axios.get(`/events_lists.php?id=${created_by.value}`, { });
    if (response.data.status) advertList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listRecords = async () => {
  try {
    const response = await axios.post('/list_mypayments.php', { userid: created_by.value });
    if (response.data.status) dataList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

function viewItem(dataList) {
    alert("Viewing: " + dataList.name);
}
function editItem(dataList) {
    alert("Editing: " + dataList.name);
}
function deleteItem(dataList) {
    if (confirm("Delete " + dataList.name + "?")) {
        dataList.value = dataList.value.filter((i) => i.id !== dataList.id);
    }
}
const makePayment = () => {

    if (email.value === '') {
        alert("Missing email address. Please contact admin.")
        return;
    }

    if (payment_type.value === '') {
        alert("Please select payment type")
        return;
    }

    if (payment_type.value === 'annual-subscription') {
        const paystack = new PaystackPop();

        paystack.newTransaction({
            key: process.env.VUE_APP_PAYSTACK_LIVE_KEY,
            email: email.value,
            amount: parseFloat(dataFee.value.amount) * 100,

            onSuccess: (transaction) => { 
                // Payment complete! Reference: transaction.reference 
                const payment_ref = transaction.reference 
                createPayment(payment_ref, dataFee.value.amount, 0)
            },
            onCancel: () => {
                // user closed popup
            }
        });
    }

    if (payment_type.value === 'advert') {
        
        if (advert_type.value === '') {
            alert("Please select advert")
            return;
        }
        if (advert_type.value === 'active') {
            alert("You already have active advert running!")
            return;
        }
        const paystack = new PaystackPop();

        paystack.newTransaction({
            key: process.env.VUE_APP_PAYSTACK_LIVE_KEY,
            email: email.value,
            amount: parseFloat(advertFee.value.amount) * 100,

            onSuccess: (transaction) => { 
                // Payment complete! Reference: transaction.reference 
                const payment_ref = transaction.reference 
                createPayment(payment_ref, advertFee.value.amount, advert_type.value)
            },
            onCancel: () => {
                // user closed popup
            }
        });
    }

    if (payment_type.value === 'levy') {

        if (customAmount.value === '') {
            alert("Please enter exact levy amount!")
            return;
        }

        const paystack = new PaystackPop();

        paystack.newTransaction({
            key: process.env.VUE_APP_PAYSTACK_LIVE_KEY,
            email: email.value,
            amount: parseFloat(customAmount.value) * 100,

            onSuccess: (transaction) => { 
                // Payment complete! Reference: transaction.reference 
                const payment_ref = transaction.reference 
                createPayment(payment_ref, customAmount.value, 0)
            },
            onCancel: () => {
                // user closed popup
            }
        });
    }

    if (payment_type.value === 'sponsorship') {

        if (customAmount.value === '') {
            alert("Please enter amount your want to sponsor")
            return;
        }

        const paystack = new PaystackPop();

        paystack.newTransaction({
            key: process.env.VUE_APP_PAYSTACK_LIVE_KEY,
            email: email.value,
            amount: parseFloat(customAmount.value) * 100,

            onSuccess: (transaction) => { 
                // Payment complete! Reference: transaction.reference 
                const payment_ref = transaction.reference 
                createPayment(payment_ref, customAmount.value, 0)
            },
            onCancel: () => {
                // user closed popup
            }
        });
    }

    if (payment_type.value === 'donation') {

        if (customAmount.value === '') {
            alert("Please enter amount your want to sponsor")
            return;
        }

        const paystack = new PaystackPop();

        paystack.newTransaction({
            key: process.env.VUE_APP_PAYSTACK_LIVE_KEY,
            email: email.value,
            amount: parseFloat(customAmount.value) * 100,

            onSuccess: (transaction) => { 
                // Payment complete! Reference: transaction.reference 
                const payment_ref = transaction.reference 
                createPayment(payment_ref, customAmount.value, 0)
            },
            onCancel: () => {
                // user closed popup
            }
        });
    }
   
}
const getMembershipFees = async () => {
  try {
    const response = await axios.get('/annual_subscriptions_fees.php', { });
    if (response.data.status) dataFee.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const getAdvertFees = async () => {
  try {
    const response = await axios.get('/advert_fee.php', { });
    if (response.data.status) advertFee.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const createPayment = async (reference, fee_amount, advert_id) => {
  try {
    const response = await axios.post('/fee_payment.php', { user_id: created_by.value, amount: fee_amount, email: email.value, description: reference, payment_status: payment_type.value, advert_id: advert_id });
    if (response.data.status) {
      alert(response.data.message) 
      window.location.reload();
    }
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};
function closeModal() {
  showModal.value = false;
}
</script>

<style scoped>
.btn-secondary{
    width: 80px !important;
}
.btn-success{
    width: 190px !important;
    background: #ED4E24 !important;
    color: #fff !important;
}
.setup-container {
    min-height: 100vh;
    padding: 24px;
}
.application-title{
    text-align: left;
}
/* Header: Setup button + search bar */
.header-search {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    width: 100%;
    margin-bottom: 16px;
}

/* Search bar */
.search-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    padding: 8px 12px;
    flex: 1 1 200px;
    /* allows shrinking */
    max-width: 350px;
}

.search-bar input {
    border: none;
    outline: none;
    width: 100%;
    font-size: 16px;
}

/* Table styles */
.table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;
    border-radius: 8px;
    overflow-x: auto;
}

.table thead {
    display: table-header-group;
}

.table tbody {
    display: table-row-group;
}

.table th,
.table td {
    border: 1px solid #E9ECEF;
    border-radius: 8px;
    box-shadow: #6C757D33 0px 1px 3px 0px, #6C757D1A 0px 1px 2px 0px;
    padding: 12px 16px;
    text-align: left;
    font-size: 14px;
}

.table th {
    background: #fff;
    color: #6C757D;
}

.actions {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.setup-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: #fff;
    color: #DB6813;
    border: 1px solid #DB6813;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}

/* Buttons */
.btn {
    width: 36px;
    height: 36px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    color: #343A40;
    background: white;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
}

.btn:hover {
    border: 1px solid #0DCAF0;
    color: #0DCAF0;
}

.btn .icon {
    width: 18px;
    height: 18px;
}

/* Pagination */
.pagination {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 12px;
}

.pagination button {
    width: 36px;
    height: 36px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    color: #343A40;
    background: white;
    cursor: pointer;
}

.pagination button.active {
    border: 1px solid #0057FC;
    color: #0057FC;
}

.pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #E9ECEF;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .setup-container {
        padding: 12px;
    }

    .table th,
    .table td {
        padding: 8px 10px;
        font-size: 12px;
    }

    .search-bar {
        flex: 1 1 100%;
        margin-top: 8px;
    }

    .setup-btn {
        padding: 6px 10px;
        font-size: 12px;
    }

    .btn {
        width: 32px;
        height: 32px;
    }

    .btn .icon {
        width: 16px;
        height: 16px;
    }

    .pagination button {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }

    /* Make table scrollable on mobile */
    .table {
        display: block;
        overflow-x: auto;
        white-space: nowrap;
    }
}
</style>
